import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Rules } from 'Validation';
import ModalForm from 'Modals/components/ModalForm';
import ModalInput from 'Modals/components/ModalForm/ModalInput';
import ModalSyncedInput from 'Modals/components/ModalForm/ModalSyncedInput';

class CreateAccountModal extends React.Component {
  static init(props) {
    const elementId = props.id || 'createAccountModal';

    ReactDOM.render(
      <CreateAccountModal {...props} />,
      document.getElementById(elementId),
    );
  }

  static handleDownloadClick() {
    window._track('Download Document', 'New Account Modal - Shared');
  }

  static getEmailProps() {
    const emailProps = {
      id: 'email',
      htmlFor: 'email',
      label: 'E-mail:',
      name: 'email',
      type: 'text',
      validations: [Rules.required, Rules.email],
    };
    return emailProps;
  }

  static getSyncedPasswordProps() {
    const syncedPasswordProps = {
      id: 'password',
      htmlFor: 'password',
      label: 'Password:',
      name: 'password',
      type: 'password',
      autocomplete: false,
      hiddenId: 'confirmPassword',
      hiddenHtmlFor: 'confirmPassword',
      hiddenLabel: 'Confirm Password:',
      hiddenName: 'confirm_password',
    };
    return syncedPasswordProps;
  }

  static getPasswordProps() {
    const passwordProps = {
      id: 'password',
      htmlFor: 'password',
      label: 'Password:',
      name: 'password',
      type: 'password',
      autocomplete: false,
      validations: [Rules.required],
    };
    return passwordProps;
  }

  static getConfirmPasswordProps() {
    const confirmPasswordProps = {
      id: 'confirmPassword',
      htmlFor: 'confirmPassword',
      label: 'Confirm Password:',
      name: 'confirm_password',
      type: 'password',
      autocomplete: false,
      validations: [Rules.required, Rules.passwordConfirm],
    };
    return confirmPasswordProps;
  }

  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getShareKeyProps = this.getShareKeyProps.bind(this);
  }

  getShareKeyProps() {
    const shareKeyProps = {
      id: 'shareKey',
      htmlFor: 'shareKey',
      label: 'shareKey:',
      name: 'share_key',
      type: 'hidden',
      value: this.props.shareKey,
    };
    return shareKeyProps;
  }

  handleSubmit(event) {
    this.props.onSubmit(event);
  }

  render() {
    const emailProps = CreateAccountModal.getEmailProps();
    const emailInputField = <ModalInput key={emailProps.id} {...emailProps} />;

    const inputs = [emailInputField];
    if (this.props.hideConfirmPassword) {
      const syncedPasswordProps = CreateAccountModal.getSyncedPasswordProps();
      const syncedPasswordField = (
        <ModalSyncedInput
          key={`${syncedPasswordProps.id}-${syncedPasswordProps.hiddenId}`}
          {...syncedPasswordProps}
        />
      );
      inputs.push(syncedPasswordField);
    } else {
      const passwordProps = CreateAccountModal.getPasswordProps();
      const passwordInputField = <ModalInput key={passwordProps.id} {...passwordProps} />;

      const confirmPasswordProps = CreateAccountModal.getConfirmPasswordProps();
      const confirmPasswordInputField = (
        <ModalInput
          key={confirmPasswordProps.id}
          {...confirmPasswordProps}
        />
      );

      inputs.push(passwordInputField);
      inputs.push(confirmPasswordInputField);
    }


    if (this.props.shareKey) {
      const shareKeyProps = this.getShareKeyProps();
      const shareKeyField = <ModalInput key={shareKeyProps.id} {...shareKeyProps} />;

      inputs.push(shareKeyField);
    }

    const modalErrorStyle = {
      fontSize: '16px',
    };

    return (
      <div id="createAccountModal" className="pane hide modal fade">
        <div className="modal-header">
          <span>{this.props.heading}</span>
          <span>
            <button
              id="download_button-modal"
              onClick={CreateAccountModal.handleDownloadClick}
              className="btn" title="Download Document"
            />
          </span>
        </div>
        <div className="modal-body">
          <h3 className="centered">{this.props.bodyHeading}</h3>
          <br />
          <div
            id="createAccountModalError"
            className="alert alert-danger hide"
            style={modalErrorStyle}
          />
          <ModalForm
            inputs={inputs}
            onSubmit={this.handleSubmit}
            submitLabel="Create Account"
          />
        </div>
      </div>
    );
  }

}

CreateAccountModal.defaultProps = {
  shareKey: '',
  hideConfirmPassword: true,
};

CreateAccountModal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  shareKey: PropTypes.string,
  heading: PropTypes.string.isRequired,
  bodyHeading: PropTypes.string.isRequired,
  hideConfirmPassword: PropTypes.bool,
};

export default CreateAccountModal;



// WEBPACK FOOTER //
// ./src-react/Modals/CreateAccount/index.jsx